import { useEffect } from 'react';
import confetti from 'canvas-confetti';
import { STAGE_LABEL, STAGE_LOOK, previousStage, speciesEmoji } from '../utils/guardian';

function StageAvatar({ species, stage, faded }) {
  const look = STAGE_LOOK[stage] || STAGE_LOOK.hatchling;
  const emoji = stage === 'egg' ? '🥚' : speciesEmoji(species);
  return (
    <div className={`flex flex-col items-center gap-1 ${faded ? 'opacity-50' : ''}`}>
      <span className={`flex items-center justify-center rounded-full leading-none ${look.size} ${faded ? '' : look.ring}`}>
        {emoji}
      </span>
      <span className="text-xs font-bold text-gray-600">{STAGE_LABEL[stage] || stage}</span>
    </div>
  );
}

function GuardianGrowth({ guardian, onContinue }) {
  useEffect(() => {
    confetti({ particleCount: 120, spread: 90, origin: { y: 0.5 } });
  }, []);

  const before = previousStage(guardian.stage);

  return (
    <div
      className="flex flex-col items-center gap-4 rounded-2xl border-2 border-black bg-white p-8 shadow-brutal"
      data-testid="guardian-growth"
    >
      <div className="flex items-end gap-4">
        <StageAvatar species={guardian.species} stage={before} faded />
        <span className="pb-6 text-2xl text-gray-400">➜</span>
        <StageAvatar species={guardian.species} stage={guardian.stage} />
      </div>
      <p className="text-center text-xl font-extrabold text-gray-900">
        {guardian.name ? `${guardian.name}长大啦!` : '你的守护兽长大啦!'}
      </p>
      <p className="text-center text-gray-600">
        进化成了 <span className="font-bold text-qiji-coral">{STAGE_LABEL[guardian.stage] || guardian.stage}</span> 🎉
      </p>
      <button
        type="button"
        onClick={onContinue}
        className="mt-2 rounded-lg bg-qiji-mint px-6 py-3 text-base font-bold text-gray-900
                   border-2 border-black shadow-brutal-sm transition
                   hover:-translate-y-0.5 active:translate-y-0 active:shadow-none"
      >
        太棒了!
      </button>
    </div>
  );
}

export default GuardianGrowth;
